"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.InjectedComponent = void 0;
var preact_1 = require("preact");
var styles = require("./injected-component.scss");
var InjectedComponent = /** @class */ (function (_super) {
    __extends(InjectedComponent, _super);
    function InjectedComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._root = null;
        return _this;
    }
    InjectedComponent.prototype.shouldComponentUpdate = function () {
        return false;
    };
    InjectedComponent.prototype.componentDidMount = function () {
        var _a = this.props, onCreate = _a.onCreate, label = _a.label;
        if (!onCreate) {
            return;
        }
        var parentElement = this._root;
        if (!parentElement) {
            return;
        }
        onCreate({ parent: parentElement });
    };
    InjectedComponent.prototype.componentWillUnmount = function () {
        var _a = this.props, onDestroy = _a.onDestroy, label = _a.label;
        var parentElement = this._root;
        if (!parentElement || !onDestroy) {
            return;
        }
        onDestroy({ parent: parentElement });
    };
    InjectedComponent.prototype.render = function () {
        var _this = this;
        var _a = this.props, label = _a.label, fillContainer = _a.fillContainer;
        var className = fillContainer ? styles.fillContainer : '';
        return ((0, preact_1.h)("div", { "data-contrib-injected": label, className: className, ref: function (ref) { return (_this._root = ref); } }));
    };
    return InjectedComponent;
}(preact_1.Component));
exports.InjectedComponent = InjectedComponent;
//# sourceMappingURL=injected-component.js.map